import { SxProps } from '@mui/material';
import { PatientWaitingDto } from './patient.model';
import { RequestStatus } from 'models/requestStatus.model';

export enum WAITING_ROOM_COLOR {
  Waiting = '#5076FF',
  ConsultingSocialWorker = '#FD60D1',
  ConsultingDoctor = '#F39238',
  ConsultingOther = '#F0E261',
  Refused = '#FF4036',
  EndConsultation = '#50F076',
  ConsultingPsychologist = '#963ff2',
}

export enum ChangingStatus {
  Waiting = 'Waiting',
  ConsultingSocialWorker = 'ConsultingSocialWorker',
  ConsultingDoctor = 'ConsultingDoctor',
  ConsultingPsychologist = 'ConsultingPsychologist',
  ConsultingOther = 'ConsultingOther',
}

export enum WaitingRoomStatus {
  Waiting = 'Waiting',
  ConsultingSocialWorker = 'ConsultingSocialWorker',
  ConsultingDoctor = 'ConsultingDoctor',
  ConsultingOther = 'ConsultingOther',
  Refused = 'Refused',
  EndConsultation = 'EndConsultation',
  ConsultingPsychologist = 'ConsultingPsychologist',
}

export type WaitingRoom = {
  id: string;
  createdDate: Date;
  updatedDate: Date;
  status: WaitingRoomStatus;
  remark: string;
  patient: PatientWaitingDto;
  consultationRequests: RequestStatus[];
};

export type WaitingRoomAddPatient = {
  patientId: string;
  centerId: string;
  date: Date;
  consultationRequests: RequestStatus[];
};

export type WaitingRoomCardProps = {
  status: WaitingRoomStatus;
  firstname?: string;
  lastname?: string;
  isIncident?: boolean;
  consultationRequests?: RequestStatus[];
  onClick: () => void;
};

export type WaitingRoomListProps = {
  sx?: SxProps;
  onClick: (waitingroomId: string) => void;
  isListHistoricized?: boolean;
  onClose?: () => void;
};
